import { Engine } from './engine/Engine'
// import { Experience } from './engine/Experience'
import { GtlfModel } from './models/GtlfModel'
import { Point, Position } from './models/Points'

export const createThreeView = (
  canvas: HTMLCanvasElement, building:
    { path: string, position: Position },
  points: Point[],disable?: boolean): Engine => {
  return new Engine({
    canvas: canvas,
    experience: { model: GtlfModel, building },
    data: points,
    info: {
      title: '三维模型',
      description: ''
      // description: '浙江博鉴技术支持'
    },
    disable: !!disable
    // canvas: document.querySelector('#canvas') as HTMLCanvasElement,
    // experience: Demo
    // experience: class implements Experience {
    //   resources = []
    //   init() {}
    //   update() {}
    //   resize() {}
    // }
  })
}
